import http from '@/uteis/http'

const _usuarioNaoAutorizado = (err) =>
  err.response.status !== 401 || err.response.data.status === 'Perfil com acesso negado!'

export default class RecursoService {
  async getTipoConferencia (query) {
    var url = '/d0593/pae-back/v1/recurso/build/tipo/conferencia'
    return new Promise((resolve, reject) => {
      http.get(url, query).then((response) => {
        return resolve(response.data)
      }).catch(err => {
        if (_usuarioNaoAutorizado(err)) {
          return reject(err)
        }

        http.post(url).then((response) => {
          return resolve(response.data)
        }).catch(() => {
          return reject(err)
        })
      })
    })
  }
}
